import { createFileRoute } from '@tanstack/react-router';
import { EnvCheckPage } from '@features/admin/env-check';

/**
 * Bez `validateSearch` a bez `beforeLoad` načítání: přehled nemá filtry ani stránkování
 * a data se tahají až v komponentě, aby se obvolávání všech služeb (jednotky sekund)
 * nedělalo při každé navigaci na route.
 */
export const Route = createFileRoute('/admin/env-check/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EnvCheckPage />;
}
